import { Device } from 'clipsal-cortex-types/src/api/api-site';

export const checkIfOperatingStateErrorCanBeIgnored = (device: Device) => {
  const { operating_state: operatingState, is_hybrid_inverter: isHybridInverter } = device;
  // If the device is solar inverter then do not show the not connected error
  const canIgnoreInverterConnectionError = !isHybridInverter && operatingState === 'NOT_CONNECTED';
  const hasOperatingState = operatingState !== null;
  return !hasOperatingState || canIgnoreInverterConnectionError;
};
